<template>
    <div class="green-box" v-if="giveaway">
        <div class="giveaway-box-title-container">
            FREE <span class="giveaway-box-title">{{giveaway.Title}}</span> GIVEAWAY. SIGNUP AND WIN.
        </div>
        <div class="countdown">
            <div class="text-title text-pink">
                <span class="text-black text-bold">{{countdown.days}}</span> days 
                <span class="text-black text-bold">{{countdown.hours}}</span> hours 
                <br class="line-break">&nbsp;
                <span class="text-black text-bold">{{countdown.minutes}}</span> minutes 
                <span class="text-black text-bold">{{countdown.seconds}}</span> seconds
            </div>
        </div>
        <div class="moreinfo">
            <a href="/giveaway">
                <button class="button button-small button-green">MORE INFO</button>
            </a>
        </div>
    </div>
</template>

<script setup lang="ts">
import { ref, onMounted } from 'vue'
import api from '@/api'

const countdown = ref({
    days: 0,
    hours: 0,
    minutes: 0,
    seconds: 0
})

const giveaway = ref<any>(null)

const startCountdown = () => {
    if (giveaway.value?.MillisecondsLeft && giveaway.value.MillisecondsLeft > 0) {
        countdown.value.days = Math.floor(giveaway.value.MillisecondsLeft / (1000 * 60 * 60 * 24))
        countdown.value.hours = Math.floor((giveaway.value.MillisecondsLeft % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60))
        countdown.value.minutes = Math.floor((giveaway.value.MillisecondsLeft % (1000 * 60 * 60)) / (1000 * 60))
        countdown.value.seconds = Math.floor((giveaway.value.MillisecondsLeft % (1000 * 60)) / 1000)
        giveaway.value.MillisecondsLeft = giveaway.value.MillisecondsLeft - 1000
    }

    setInterval(() => {
        if (giveaway.value?.MillisecondsLeft && giveaway.value.MillisecondsLeft > 0) {
            countdown.value.days = Math.floor(giveaway.value.MillisecondsLeft / (1000 * 60 * 60 * 24))
            countdown.value.hours = Math.floor((giveaway.value.MillisecondsLeft % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60))
            countdown.value.minutes = Math.floor((giveaway.value.MillisecondsLeft % (1000 * 60 * 60)) / (1000 * 60))
            countdown.value.seconds = Math.floor((giveaway.value.MillisecondsLeft % (1000 * 60)) / 1000)
            giveaway.value.MillisecondsLeft = giveaway.value.MillisecondsLeft - 1000
        } else {
            countdown.value.days = 0
            countdown.value.hours = 0
            countdown.value.minutes = 0
            countdown.value.seconds = 0
        }
    }, 1000)
}

const init = async () => {
    try {
        const response = await api.getGiveawayInfo()
        const giveawayData = response.data
        if (giveawayData && giveawayData.IsStillOn) {
            giveaway.value = giveawayData
            startCountdown()
        }
    } catch (error) {
        console.error('Error fetching giveaway info:', error)
    }
}

onMounted(() => {
    init()
})
</script>
